import type { MigrationManifest } from "redux-persist";

export const PERSIST_VERSION = 6;

const persistMigrations: MigrationManifest = {};

export default persistMigrations;
